import { RootState } from 'store/configureStore';
import { RepaymentStrategy } from '../../RepaymentStrategy';
import { State as CaseState } from '../../../store/cases/types';

const getInitialRepaymentDataSelector = (state: RootState): RepaymentStrategy => {
  const reduxCase = state.currentCase as NonNullable<CaseState>;
  const caseData = reduxCase.initialData as NonNullable<typeof reduxCase.data>;
  return caseData.case.repaymentStrategy as RepaymentStrategy;
};

export default getInitialRepaymentDataSelector;
